module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16_1080.a665887b.webp";